<style scoped>
.help-content{
  max-width: 1280px;
  margin: 0 auto;
  padding: 5px 10px;
}
.help-menu{
    display: inline-block;
}
</style>

<template>
    <div class="help-content">

        <Affix :offset-top="80" use-capture style="widht:240px">
            <helpMenu/>
        </Affix>

       <document/>
    </div>
</template>

<script>
import helpMenu from './menu'
import document from './document'

export default {
  components: {
    helpMenu, document
  }
}
</script>
